import { useState } from 'react';
import { Icon } from '../ui/Icon.js';

/**
 * System, light, dark, in that order.
 *
 * Shared by the console header and the client TMS header: the choice lives in
 * localStorage (main.tsx applies it before the first paint), so a tab opened on /manage/...
 * already shows it, but had no way to change it (owner, 15 September 2026).
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<string>(
    () => document.documentElement.dataset.theme ?? 'system',
  );
  const cycle = () => {
    const next = theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system';
    setTheme(next);
    if (next === 'system') delete document.documentElement.dataset.theme;
    else document.documentElement.dataset.theme = next;
    try { localStorage.setItem('arc.theme', next); } catch { /* ignore */ }
  };
  return (
    <button
      type="button" className="arc-btn arc-btn-ghost arc-btn-icon" onClick={cycle}
      title={`Theme: ${theme}`} aria-label={`Theme: ${theme}. Click to change.`}
    >
      <Icon name={theme === 'dark' ? 'moon' : theme === 'light' ? 'sun' : 'contrast'} size={15} />
    </button>
  );
}
